import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { message, Spin } from "antd";

import * as actions from "../../actions";
import Layout from "./Form";
import { PageTitle, ReportBtn } from "lib/widget";

import * as moment from "moment";

const initialState = {
  branchId: [],
  startDate: null,
  endDate: null,
  pickStartDate: null,
  pickEndDate: null,
};

class EmployeesReport extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.onKeyValueChange = this.onKeyValueChange.bind(this);
  }

  onKeyValueChange(name, value) {
    this.setState((state, props) => {
      return { ...state, [name]: value };
    });
  }

  onDateChange = (value) => {
    this.setState({ ...this.state, ...value })
  }


  clearFilter = () => {
    this.setState(initialState);
  };

  downloadEmployee = () => {
    const {
      startDate,
      endDate,
      branchId,
      pickStartDate,
      pickEndDate,
    } = this.state;
    if (!startDate || !endDate) return message.error("Please select date");
    if (branchId.length === 0) return message.error("Please select branch");

    let start = moment(pickStartDate + " 00:00:00")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    let end = moment(pickEndDate + " 23:59:59")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    this.props.downloadEmployee(
      branchId,
      start,
      end,
      pickStartDate,
      pickEndDate
    );
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.errorMessage !== prevState.errorMessage) {
      return { errorMessage: nextProps.errorMessage };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.errorMessage !== this.props.errorMessage) {
      message.error(this.props.errorMessage);
    }
  }

  componentDidMount() {
    this.props.loadReportBranch();
  }

  render() {
    return (
      <Fragment>
        <PageTitle name="report_employee" component={null} />
        <Spin size="large" spinning={this.props.loading}>
          <Layout
            {...this.state}
            branches={this.props.branches}
            onDateChange={this.onDateChange}
            onKeyValueChange={this.onKeyValueChange}
          />
          <ReportBtn
            onDowload={this.downloadEmployee}
            onClear={this.clearFilter}
          />
        </Spin>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ reports }) => ({
  branches: reports.branches,
  loading: reports.employee_loading,
  errorMessage: reports.errorMessage,
});

const mapDispatchToProps = {
  downloadEmployee: actions.downloadEmployee.request,
  loadReportBranch: actions.loadReportBranch.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesReport);
